class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.quantity-selector__input');
    this.decreaseBtn = this.querySelector('[data-action="decrease"]');
    this.increaseBtn = this.querySelector('[data-action="increase"]');
  }

  connectedCallback() {
    this.decreaseBtn?.addEventListener('click', () => this.change(-1));
    this.increaseBtn?.addEventListener('click', () => this.change(1));
    this.input?.addEventListener('change', () => this.validate());
  }

  change(delta) {
    if (!this.input) return;
    const current = parseInt(this.input.value, 10) || 1;
    const min = parseInt(this.input.min, 10) || 1;
    const max = parseInt(this.input.max, 10) || 999;
    const newVal = Math.min(Math.max(current + delta, min), max);
    this.input.value = newVal;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  validate() {
    if (!this.input) return;
    const min = parseInt(this.input.min, 10) || 1;
    const max = parseInt(this.input.max, 10) || 999;
    let val = parseInt(this.input.value, 10);
    if (isNaN(val) || val < min) val = min;
    if (val > max) val = max;
    this.input.value = val;
  }
}

customElements.define('quantity-selector', QuantitySelector);
